import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { useAuthStore } from '../../store/useStore';
import { refertiProdottiAPI } from '../../services/refertiProdottiApi';

/**
 * «Scrivi il referto»: dalla procedura, con dentro i valori delle schede
 * compilate (in tabella) e i campi liberi (nel corpo, come prosa da
 * rileggere). Sta nella sezione Referti / Prescrizioni della procedura,
 * che e' dove uno ha finito di compilare e pensa «adesso il referto».
 * Lo vede chi e' collegato a un medico.
 */
const BottoneRefertoDaProcedura = ({ visitaId }) => {
    const utente = useAuthStore((s) => s.user);
    const navigate = useNavigate();
    const [inCorso, setInCorso] = useState(false);
    const [errore, setErrore] = useState(null);
    /* Le mappe delle zone trattate entrano nel referto se il medico lo
       vuole: accesa per difetto, e' lui che sceglie cosa mettere nel
       proprio referto. */
    const [conMappe, setConMappe] = useState(true);

    if (!utente?.medico_id) return null;

    const genera = async () => {
        setInCorso(true);
        setErrore(null);
        try {
            const r = await refertiProdottiAPI.daVisita(visitaId, { includi_mappe: conMappe });
            navigate(`/referti/${r.data.data.referto.id}`);
        } catch (e) {
            setErrore(e?.response?.data?.message || e?.message || 'Errore nella generazione del referto');
            setInCorso(false);
        }
    };

    return (
        <>
            {errore && <span className="pd-errore-inline">{errore}</span>}
            <label className="pd-spunta" title="Le tavole con i punti delle zone trattate, stampate nel referto">
                <input type="checkbox" checked={conMappe} onChange={(e) => setConMappe(e.target.checked)} />
                con le mappe
            </label>
            <button className="pd-add" onClick={genera} disabled={inCorso}
                    title="Crea un referto con i valori e i testi di questa procedura copiati dentro">
                <FileText size={13} strokeWidth={1.8} aria-hidden="true" />
                {inCorso ? ' Creo il referto…' : ' Scrivi il referto'}
            </button>
        </>
    );
};

export default BottoneRefertoDaProcedura;
